import { Inject, Injectable } from '@angular/core';
import { PaginatedRepository } from '../pagination/paginated.repository';
import { HubReport } from '../../interfaces/hub-reports/hub-report';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { REG_HUB_COMMON_CONFIG, RegHubCommonConfig } from '../../reg-hub-common-config';
import { BehaviorSubject, of, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HubReportsService extends PaginatedRepository<HubReport> {
  protected override _baseLink: string;

  public currentHubReport$ = new BehaviorSubject<HubReport | undefined>(undefined);

  constructor(
    http: HttpClient,
    messageService: ToastrService,
    @Inject(REG_HUB_COMMON_CONFIG) private config: RegHubCommonConfig) {
    super(http, messageService);
    this._baseLink = `${config.rootUrl}/HubReports`;
  }

  public getHubReport(hubReportID: string) {
    return this.http.get<HubReport>(`${this._baseLink}/${hubReportID}`);
  }

  public getHubReportWithUboTrees(hubReportID: string) {
    const headers = new HttpHeaders().append('accept', 'application/vnd.reghub.hub-report-with-ubo-trees+json');
    return this.http.get<HubReport>(`${this._baseLink}/${hubReportID}`, { headers: headers })
      .pipe(tap(report => this.currentHubReport$.next(report)));
  }
  
  public getHubReportWithUboTreesByOrder(orderID: string, hideNotFoundError: boolean = true) {
    if (this.currentHubReport$.value) {
      return of(this.currentHubReport$.value);
    } else {
      const headers = new HttpHeaders().append('accept', 'application/vnd.reghub.hub-report-with-ubo-trees+json');
      let params = new HttpParams();

      if (hideNotFoundError) {
        params = params.append('hideErrorsStatusCodes', 404);
      }

      return this.http.get<HubReport>(`${this.config.rootUrl}/Orders/${orderID}/HubReport`, { headers: headers, params: params })
        .pipe(tap(report => this.currentHubReport$.next(report)));
    }
  }

  public generateDocument(hubReportID: string) {
    return this.http.post(`${this._baseLink}/${hubReportID}/Generate`, { });
  }
}
